import { CrudRouter, ParamType } from '../../../Routers/CrudRouter';
import { ArticleType } from '../../../../swagger/putujmoAdminService';
import { ArticleTable } from '../../Table/ArticleTable';
import { ReadArticle } from '../../Crud/ReadArticle';
import { UpdateArticle } from '../../Crud/UpdateArticle';
import { CreateArticle } from '../../Crud/CreateArticle';
import { propertyOf } from '../../../../utils/propertyOf';

export const PPSCardsRouter = () => {
	return (
		<CrudRouter
			ListComponent={ArticleTable}
			ReadComponent={ReadArticle}
			UpdateComponent={UpdateArticle}
			CreateComponent={CreateArticle}
			additionalData={{ articleType: ArticleType.PPSCard }}
			paramName={propertyOf<ParamType>('id')}
		/>
	);
};

